/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * Public Key according to
 *           - [Verifiable Credential Data Integrity 1.0 - 2.3.1 Verification Methods](https://www.w3.org/TR/vc-data-integrity/#verification-methods).
 */
export interface KeyPublic {
    /** Public key in Base58-encoded format. */
    publicKeyBase58?: string;
    /**
     * Public key in JWK format.
     *         Take a look [RFC 7517](https://datatracker.ietf.org/doc/html/rfc7517).
     */
    publicKeyJwk: string;
    /**
     * Public key in Multibase format.
     *         The related specifications:
     *         - IETF Draft [The Multibase Data Format](https://datatracker.ietf.org/doc/html/draft-multiformats-multibase)
     *         - GitHub Repository [github.com/multiformats/multibase](https://github.com/multiformats/multibase)
     *         - [Decentralized Identifiers (DIDs) v1.0](https://www.w3.org/TR/did-core/)
     *         - [Verifiable Credential Data Integrity 1.0](https://www.w3.org/TR/vc-data-integrity/) - [Section 2.4 Multibase](https://www.w3.org/TR/vc-data-integrity/#multibase-0)
     *         This representation widely used in SSI specifications and format.
     *         .
     */
    publicKeyMultibase: string;
    /** Public key in PEM-encoded PKIX format. */
    publicKeyPem: string;
    /**
     * The specification of asymmetric key-pair.
     *
     * | Truvity | JWX - KeyType | JWX - Curve | FIPS  | SEC2      | OpenSSL    | AWS KMS       |
     * |---------|---------------|-------------|-------|-----------|------------|---------------|
     * | ED25519 | OKP           | Ed25519     |       |           | ed25519    |               |
     * | P256    | EC            | P-256       | P-256 | secp256r1 | prime256v1 | ECC_NIST_P256 |
     * | P384    | EC            | P-384       | P-384 | secp384r1 | secp384r1  | ECC_NIST_P384 |
     *
     * Useful third-party documentation:
     * - [openssl-genrsa - generate an RSA private key](https://www.openssl.org/docs/manmaster/man1/openssl-genpkey.html).
     * - [openssl-ec, ec - EC key processing](https://www.openssl.org/docs/man1.0.2/man1/ec.html)
     * - [openssl-genrsa - generate an RSA private key](https://www.openssl.org/docs/man3.0/man1/openssl-genrsa.html)
     * - [openssl-pkcs8 - PKCS#8 format private key conversion command](https://www.openssl.org/docs/manmaster/man1/openssl-pkcs8.html)
     * - [JWX - github.com/lestrrat-go/jwx](https://github.com/lestrrat-go/jwx/blob/main/cmd/jwx/README.md)
     * - [FIPS 186-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.186-4.pdf).
     * - [SEC2](https://www.secg.org/sec2-v2.pdf).
     * - [AWS KMS - Asymmetric key specs](https://docs.aws.amazon.com/kms/latest/developerguide/asymmetric-key-specs.html)
     * .
     */
    type: Truvity.KeyPublicType;
}
